import { action } from 'satcheljs';
import { IEntityGridColumns } from '..';

export const onEntityGridColumnsChanged = action('onEntityGridColumnsChanged', (entityColumnsData: IEntityGridColumns) => ({
  entityColumnsData
}));
